import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import axios from "utils/axios";
import { PUBLIC_VENDOR_UPDATE_URL } from "config/services";
import VendorInvitationForm from "./VendorInvitationForm";

const VendorInvitationPage = (props) => {
    const [params] = useSearchParams();
    const token = params.get("updateToken") || "";
    const isUpdateLink = params.has("updateToken");
    const [profile, setProfile] = useState(null);
    const [attempt, setAttempt] = useState(0);

    useEffect(() => {
        if (!token) return undefined;
        const controller = new AbortController();
        setProfile({ token, status: "loading" });
        axios.get(PUBLIC_VENDOR_UPDATE_URL, {
            headers: { "x-vendor-update-token": token }, signal: controller.signal,
        }).then((response) => {
            if (controller.signal.aborted) return;
            if (!response.data?.payload?.vendor?.vendorId) throw new Error("Invalid profile response");
            setProfile({ token, status: "ready", ...response.data.payload });
        }).catch((error) => {
            if (controller.signal.aborted) return;
            setProfile({
                token, status: "error",
                message: error.response?.data?.message || "Unable to load this vendor profile. Please try again.",
                retryable: !error.response || error.response.status >= 500,
            });
        });
        return () => controller.abort();
    }, [token, attempt]);

    if (!isUpdateLink) return <VendorInvitationForm {...props} />;
    if (token && (profile?.token !== token || profile.status === "loading")) {
        return <div role="status" className="flex min-h-screen items-center justify-center gap-3 bg-[#FFF8F2] text-sm text-[#8F430F]">
            <span className="h-6 w-6 animate-spin rounded-full border-2 border-[#FFD9BE] border-t-[#FD6600]" />
            Loading your vendor profile...
        </div>;
    }
    if (!token || profile.status === "error") {
        return <main className="flex min-h-screen items-center justify-center bg-[#FFF8F2] p-6">
            <section role="alert" className="max-w-lg rounded-2xl border border-[#F0DDCE] bg-white p-8 shadow-sm">
                <h1 className="text-xl font-semibold text-gray-900">Vendor profile update unavailable</h1>
                <p className="mt-3 text-sm leading-6 text-gray-600">{profile?.message || "This update link is invalid. Please ask the company for a new link."}</p>
                {token && profile?.retryable && <button type="button" onClick={() => setAttempt((value) => value + 1)} className="mt-5 rounded-lg bg-[#FD6600] px-4 py-2 text-sm font-semibold text-white">Try again</button>}
            </section>
        </main>;
    }
    return <>
        <Helmet><meta name="referrer" content="no-referrer" /></Helmet>
        <VendorInvitationForm key={token} isEdit editVendorDetails={profile.vendor} publicUpdateToken={token} publicEntityName={profile.entityName} />
    </>;
};

export default VendorInvitationPage;
